import HeroComp from "@/components/hero";
import { HERO_CONSTANTS } from "./constants";

const HeroComponent = () => {
  return <HeroComp list={HERO_CONSTANTS} />;
};

export default HeroComponent;
